import React from "react";

const Footer = () => (
  <footer>
    <p>&copy; Stacey Rozich {new Date().getFullYear()}</p>
  </footer>
);

export default Footer;
